import { CustomType } from "PFTypes";

export const getCustomTypeName = (customType: CustomType | undefined) =>
  customType?.displayAs ?? customType?.display_as ?? customType?.name ?? "";
